module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/campaign'));
  PluginManager.registerAudienceMatcher('campaign', require('./matchers/campaign'));
};
